import { Hero } from "../components/Hero";
import DetailsSection from "../components/DetailsSection";
import { WhyChooseUsSection } from "../components/DestinationsSection";
import ServiceSection from "../components/ServicesSection";
import TestimonialsSection from "../components/TestimonialCarousel";
import FAQSection from "../components/FAQ";
import Enquiries from "../components/Enquiries";
import { CTASection } from "../components/CTASection";
import { SEO } from "../components/SEO";

export default function HomePage() {
  return (
    <>
      <SEO
        title="Home"
        description="BeginPack Ltd provides comprehensive study abroad, migration, and flight booking services. Expert guidance for students and professionals seeking global opportunities."
        ogTitle="BeginPack Ltd - Your Gateway to Global Education & Migration"
        ogDescription="Expert study abroad, migration, and flight booking services. We help you achieve your dreams of international education and career opportunities."
      />
      <Hero />
      <DetailsSection />
      <WhyChooseUsSection />
      <ServiceSection />
      <TestimonialsSection />
      <FAQSection />
      <Enquiries />
      <CTASection />
    </>
  );
}
